import { useEffect } from "react";

// Modal a11y + scroll lock: Escape to close, Tab focus trap, lock page scroll (pauses Lenis).
export const useModalEffects = (isOpen, onClose, containerRef) => {
  useEffect(() => {
    if (!isOpen) return;

    const lenis = window.__lenis;
    lenis?.stop();
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const focusables = () => {
      const el = containerRef?.current;
      if (!el) return [];
      return Array.from(
        el.querySelectorAll(
          'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
        )
      ).filter((n) => n.offsetParent !== null);
    };

    const t = setTimeout(() => {
      const f = focusables();
      (f[0] || containerRef?.current)?.focus?.();
    }, 20);

    const onKey = (e) => {
      if (e.key === "Escape") {
        onClose();
        return;
      }
      if (e.key === "Tab") {
        const el = containerRef?.current;
        if (!el) return;
        const f = focusables();
        if (f.length === 0) {
          e.preventDefault();
          el.focus();
          return;
        }
        const first = f[0];
        const last = f[f.length - 1];
        if (!el.contains(document.activeElement)) {
          e.preventDefault();
          first.focus();
          return;
        }
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener("keydown", onKey);
    return () => {
      clearTimeout(t);
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
      lenis?.start();
    };
  }, [isOpen, onClose, containerRef]);
};
